export default __webpack_public_path__ + "static/cer-9001-6208d7c9bf95e5113a478ad402a7c73a.png";